<!-- @format -->

<ng-container *transloco="let t">
  @if (courseUnit$ | async; as data) {
    @switch (completionMethodNotification(data).type) {
      @case ("no-methods") {
        <sis-study-notification-box type="info">
          {{ t("PLAN.NO_COMPLETION_METHODS") }}
        </sis-study-notification-box>
      }
      @case ("missing-selection") {
        <sis-study-notification-box
          type="info"
          [primaryButtonText]="'CONFIRM_AND_SELECT'"
          (primaryClickAction)="openSelectCompletionMethodModal()">
          {{ t("PLAN.MISSING_COMPLETION_METHOD") }}
        </sis-study-notification-box>
      }
      @case ("single-selected") {
        <sis-study-notification-box
          [useFudisLink]="true"
          type="approved"
          [tertiaryButtonText]="'PLAN.VIEW_COMPLETION_METHOD'"
          (tertiaryClickAction)="openSelectCompletionMethodModal()">
          {{ t("PLAN.COMPLETION_METHOD_CHOSEN", { completion_method_index: getCompletionMethodIndex(data) }) }}
        </sis-study-notification-box>
      }
      @case ("multiple-selected") {
        <sis-study-notification-box
          [useFudisLink]="true"
          type="approved"
          [secondaryButtonText]="'PLAN.CHANGE_COMPLETION_METHOD'"
          (secondaryClickAction)="openSelectCompletionMethodModal()">
          {{ t("PLAN.COMPLETION_METHOD_CHOSEN", { completion_method_index: getCompletionMethodIndex(data) }) }}
        </sis-study-notification-box>
      }
    }
  }
</ng-container>
